import { Icon } from "@mindlercare/ui-web";
import { StyledToggleButton } from "./drawer.styles";
import { useDrawerContext } from "./DrawerContextProvider";

export const DrawerToggleButton = () => {
  const { isDrawerOpen, toggleDrawer } = useDrawerContext();
  return (
    <StyledToggleButton onClick={toggleDrawer} $isDrawerOpen={isDrawerOpen}>
      <Icon.Toggle width={20} />
    </StyledToggleButton>
  );
};
